// extracted by mini-css-extract-plugin
module.exports = {"targetAmount":"target-amount_targetAmount__1qrlz","btn":"target-amount_btn__2EnnO","content":"target-amount_content__1cZQx"};